import React from 'react';
import PropTypes from 'prop-types';

/**
 * TipBox Component
 *
 * Info box with tips and helpful information for users
 *
 * Props:
 * - icon: Icon to display (default: 💡)
 * - title: Tip title
 * - text: Tip body text
 */
function TipBox({ icon = '💡', title, text }) {
  return (
    <div className="bg-blue-50 border-2 border-blue-200 rounded-2xl p-5 mt-5">
      <div className="flex items-start gap-3">
        <div className="text-3xl flex-shrink-0">{icon}</div>
        <div className="flex-1">
          <h4 className="font-bold text-blue-900 text-lg mb-2">{title}</h4>
          <p className="text-blue-800 text-base leading-relaxed">{text}</p>
        </div>
      </div>
    </div>
  );
}

TipBox.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
};

export default TipBox;
